
import {createRouter, createWebHistory} from 'vue-router';

import HomePage from '@/pages/HomePage.vue'
import ContactPage from '@/pages/ContactPage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import ResetPasswordPage from '@/pages/ResetPasswordPage.vue'
import ProfilePage from '@/pages/user/ProfilePage.vue'

import AdminRoutes from '@/router/admin'
import FacilityRoutes from '@/router/facility'
import CARSRoutes from '@/router/cars'
import ARESRoutes from '@/router/ares'

const newRoutes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: {
          label: 'Home'
        }
    }, {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage
    }, {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    }, {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPasswordPage
    }, {
      path: '/profile',
      name: 'UserProfilePage',
      component: ProfilePage,
      meta: {
        title: 'User Profile'
      }
    }, {
      path: '/change-password/:passwordResetHash',
      name: 'ChangePassword',
      component: () => import('@/pages/user/ChangePassword.vue'),
      props: true,
      meta: {
        title: 'Change password'
      }
    },
    {
      path: '/cars',
      redirect: { name: 'HomePage' },
      children: CARSRoutes
    },
    {
      path: '/ares',
      redirect: { name: 'HomePage' },
      children: ARESRoutes
    },
    {
      name: 'LidarLandingPage',
      path: '/lidar/:lidarId',
      component: () => import('@/pages/lidar/LandingPage.vue'),
      props: true,
      meta: {
        title: 'Lidar System'
      }
    },
    {
      name: 'StaticPage',
      path: '/static/:slug',
      component: () => import('@/pages/StaticPage.vue'),
      props: true
    }
]
.concat(AdminRoutes)
// .concat(CARSRoutes)
.concat(FacilityRoutes)
// Also add various catch:
.concat([
  { name: 'FourOhFour', path: '/:pathMatch(.*)*', component: () => import('@/pages/FourOhFour.vue') }
])

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: newRoutes
})

export default router
